import React from 'react';

import { Body1, Body2, Body3, Body4, Caption2, Caption3, H2, H4, T3, Wrap } from 'components/Common';
import Spacing from 'components/Common/Spacing';
import useIsMobile from 'hooks/useIsMobile';
import { useNavigate } from 'react-router-dom';
import { LoginStorage } from 'shared/lib';
import { Seo } from 'shared/seo';

import { Banner, Block, Chip, RegisterButton } from './styles';

const Home = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const mobileImg = isMobile ? { maxWidth: '100%', height: 'auto' as const } : undefined;

  const seo = (
    <Seo
      title="체크메이트코리아 | 대한민국 최초 비대면 가계약 플랫폼"
      description="체크메이트코리아는 대한민국 최초 비대면 가계약 플랫폼입니다. 교환학생·유학생 등 외국인 고객에게 매물을 노출하고, 비대면으로 빠르게 가계약을 체결하세요."
      path="/"
      jsonLd={{
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '체크메이트코리아',
        url: 'https://admin.checkmatekorea.com/',
        logo: 'https://admin.checkmatekorea.com/GuideLogo.png',
        description: '대한민국 최초 비대면 가계약 플랫폼',
      }}
    />
  );

  const handleRegister = () => {
    if (LoginStorage.isLogin()) {
      alert('로그아웃 후 회원가입을 진행해주세요.');
    } else {
      navigate('/login');
    }
  };

  if (isMobile) {
    return (
      <Wrap direction="column" width="100%" className="home-mobile">
        {seo}
        <Banner>
          <Wrap direction="column" width="100%">
            <H2 color="White" style={{ fontSize: 'clamp(20px, 6vw, 26px)', lineHeight: 1.4 }}>
              체크메이트코리아와
            </H2>
            <H2 color="White" style={{ fontSize: 'clamp(20px, 6vw, 26px)', lineHeight: 1.4 }}>
              전 세계로 고객군을 넓혀보세요
            </H2>
          </Wrap>
          <Spacing height={14} />
          <Wrap direction="column" width="100%">
            <Body1 color="White" style={{ fontSize: 'clamp(14px, 4vw, 18px)', lineHeight: 1.6 }}>
              체크메이트코리아와 월 100만원
            </Body1>
            <Body1 color="White" style={{ fontSize: 'clamp(14px, 4vw, 18px)', lineHeight: 1.6 }}>
              추가수익을 달성해보세요.
            </Body1>
          </Wrap>
          <Spacing height={28} />
          <img src="/Main_Arrow_Down.svg" alt="arrow" />
        </Banner>

        {/* About */}
        <Spacing height={64} />
        <Wrap
          direction="column"
          align="center"
          width="100%"
          padding="0 24px"
          style={{ textAlign: 'center', wordBreak: 'keep-all' }}
        >
          <T3 color="Red">About</T3>
          <Spacing height={8} />
          <H4>대한민국 최초</H4>
          <H4 color="Red">비대면 가계약 플랫폼</H4>
          <Spacing height={24} />
          <img src="/GuideLogo.png" alt="logo" style={{ width: '100%', maxWidth: '200px', height: 'auto' }} />
          <Spacing height={24} />
          <Body2 color="Gray40">
            더이상 사무실에 방문하는 고객만 기다리지 마세요! 해외에 있는 고객도 가계약으로 먼저 유치해보세요.
          </Body2>
        </Wrap>

        {/* Global */}
        <Spacing height={64} />
        <Wrap
          direction="column"
          align="center"
          width="100%"
          padding="0 24px"
          style={{ textAlign: 'center', wordBreak: 'keep-all' }}
        >
          <T3 color="Red">Global</T3>
          <Spacing height={8} />
          <H4>전 세계 고객들에게</H4>
          <H4>매물 노출</H4>
          <Spacing height={24} />
          <img src="/Earth.png" alt="earth" style={{ width: '100%', maxWidth: '160px', height: 'auto' }} />
          <Spacing height={24} />
          <Body2 color="Gray40">
            교환학생, 유학생 등 입국 전 주거지 확정을 원하는 외국인 고객들을 대상으로 매물을 홍보하고, “비대면”으로 빠른
            가계약 체결이 가능합니다.
          </Body2>
          <Spacing height={20} />
          <Caption2 color="Gray40">
            (서울대, 경희대, 한국외대, 성균관대, 서강대 등 협력 대학, 어학당 홍보를 통한 외국인 임차인 “직접” 유입)
          </Caption2>
        </Wrap>

        {/* Now */}
        <Spacing height={64} />
        <Wrap
          direction="column"
          align="center"
          width="100%"
          padding="0 24px"
          style={{ textAlign: 'center', wordBreak: 'keep-all' }}
        >
          <img src="/Graph.svg" alt="graph" width="110px" height="110px" />
          <Spacing height={8} />
          <T3 color="Red">Now</T3>
          <Spacing height={8} />
          <H4>체크메이트코리아와</H4>
          <H4>함께 하세요!</H4>
          <Spacing height={24} />
          <Wrap direction="column" gap="16px" width="100%" align="center">
            <Block>
              <Chip>
                <Body3 color="White">✏️ 무료 등록</Body3>
              </Chip>
              <Wrap direction="column" gap="7px">
                <Body4>매물 등록 및 관리 기능 무료로 제공합니다.</Body4>
              </Wrap>
            </Block>
            <Block>
              <Chip>
                <Body3 color="White">🏡 편리한 매물 및 고객관리</Body3>
              </Chip>
              <Wrap direction="column" gap="7px">
                <Body4>다국어 매물 번역 시스템을 통한 간편한 매물 등록 제공</Body4>
                <Body4>대면 응대 없이 비대면으로 빠르게 가계약 확정 기능</Body4>
              </Wrap>
            </Block>
            <Block>
              <Chip>
                <Body3 color="White">📈 끝까지 책임지는 계약 진행</Body3>
              </Chip>
              <Wrap direction="column" gap="7px">
                <Body4>가계약 접수와 수락, 계약금 송금까지,</Body4>
                <Body4>체크메이트코리아가 직접 챙겨드립니다.</Body4>
              </Wrap>
            </Block>
          </Wrap>
        </Wrap>

        {/* Partner */}
        <Spacing height={64} />
        <Wrap
          direction="column"
          align="center"
          width="100%"
          padding="0 24px"
          style={{ textAlign: 'center', wordBreak: 'keep-all' }}
        >
          <T3 color="Red">Partner</T3>
          <Spacing height={8} />
          <H4>외국인 주거 시장의</H4>
          <H4>새로운 가능성을 열어갈</H4>
          <H4>파트너를 기다립니다.</H4>
          <Spacing height={24} />
          <img src="Partner.png" alt="partner" style={{ width: '100%', maxWidth: '150px', height: 'auto' }} />
          <Spacing height={24} />
          <Body2 color="Gray40">
            2024년 기준 대한민국의 외국인 인구는 250만 명을 달성했고, 빠른 속도로 늘어나고 있습니다.
          </Body2>
          <Spacing height={20} />
          <Body2 color="Gray40">
            체크메이트코리아는 높은 확장성과, 수익 창출이 기대되는 외국인 주거 시장의 메이저 주거 통합 플랫폼으로
            성장하고자 합니다.
          </Body2>
        </Wrap>

        {/* Contact */}
        <Spacing height={64} />
        <Wrap
          direction="column"
          align="center"
          background="rgba(255, 240, 240, 1)"
          width="100%"
          padding="56px 24px"
          style={{ textAlign: 'center', wordBreak: 'keep-all' }}
        >
          <T3 color="Red">Contact</T3>
          <Spacing height={8} />
          <H4>지금 체크메이트코리아에서</H4>
          <H4>외국인 고객을 만나보세요.</H4>
          <Spacing height={16} />
          <Body2 color="Gray40">
            원룸, 투룸, 쉐어하우스, 고시원, 기숙사 모두 체크메이트코리아에서 광고 가능합니다.
          </Body2>
          <Spacing height={28} />
          <RegisterButton onClick={handleRegister}>
            <Caption3 color="White">회원가입 하러가기</Caption3>
          </RegisterButton>
        </Wrap>
      </Wrap>
    );
  }

  return (
    <Wrap direction="column" width="100%">
      {seo}
      <Banner>
        <Wrap direction="column" width={isMobile ? '100%' : undefined}>
          <H2 color="White">체크메이트코리아와</H2>
          <H2 color="White">전 세계로 고객군을 넓혀보세요.</H2>
        </Wrap>
        <Spacing height={17} />
        <Body1 color="White">체크메이트코리아와 월 100만원 추가수익을 달성해보세요.</Body1>
        <Spacing height={41} />
        <img src="/Main_Arrow_Down.svg" alt="arrow" />
        <Spacing height={isMobile ? 40 : 210} />
      </Banner>
      <Spacing height={136} />
      <Wrap
        gap={isMobile ? '32px' : '67px'}
        direction={isMobile ? 'column' : 'row'}
        padding={isMobile ? '0 16px' : '0px'}
        width={isMobile ? '100%' : undefined}
      >
        <img src="/GuideLogo.png" alt="logo" height={229} style={mobileImg} />
        <Wrap direction="column" align="start" width={isMobile ? '100%' : undefined}>
          <T3 color="Red">About</T3>
          <Spacing height={7} />
          <H4>대한민국 최초</H4>

          <H4 color="Red">비대면 가계약 플랫폼 </H4>
          <Spacing height={18} />
          <Body2 color="Gray40">더이상 사무실에 방문하는 고객만 기다리지 마세요!</Body2>
          <Body2 color="Gray40">해외에 있는 고객도 가계약으로 먼저 유치해보세요. </Body2>
        </Wrap>
      </Wrap>
      <Spacing height={253} />
      <Wrap
        gap={isMobile ? '32px' : '107px'}
        direction={isMobile ? 'column-reverse' : 'row'}
        padding={isMobile ? '0 16px' : '0px'}
        width={isMobile ? '100%' : undefined}
      >
        <Wrap direction="column" align="start" width={isMobile ? '100%' : undefined}>
          <T3 color="Red">Global</T3>
          <Spacing height={7} />
          <H4>전세계 고객들에게 매물 노출</H4>
          <Spacing height={18} />
          <Body2 color="Gray40">교환학생, 유학생 등 입국 전 주거지 확정을 원하는</Body2>
          <Body2 color="Gray40">외국인 고객들을 대상으로 매물을 홍보하고,</Body2>
          <Body2 color="Gray40">“비대면”으로 빠른 가계약 체결이 가능합니다.</Body2>
          <Spacing height={25} />
          <Caption2 color="Gray40">(서울대, 경희대, 한국외대, 성균관대, 서강대 등 협력 대학,</Caption2>
          <Caption2 color="Gray40">어학당 홍보를 통한 외국인 임차인 “직접” 유입)</Caption2>
        </Wrap>
        <img src="/Earth.png" alt="earth" style={mobileImg} />
      </Wrap>
      <Spacing height={199} />
      <Wrap direction="column">
        <Wrap direction="column">
          <img src="/Graph.svg" alt="graph" width="150px" height="150px" />
          <T3 color="Red">Now</T3>
          <Spacing height={7} />
          <H4>체크메이트코리아와</H4>
          <H4>함께 하세요!</H4>
        </Wrap>
        <Spacing height={35} />
        <Wrap
          gap="25px"
          direction={isMobile ? 'column' : 'row'}
          padding={isMobile ? '0 16px' : '0px'}
          width={isMobile ? '100%' : undefined}
          align={isMobile ? 'center' : 'stretch'}
        >
          <Block>
            <Chip>
              <Body3 color="White">✏️ 무료 등록</Body3>
            </Chip>
            <Wrap direction="column" gap="7px">
              <Body4>매물 등록 및 관리 기능 무료로 제공합니다.</Body4>
            </Wrap>
          </Block>
          <Block>
            <Chip>
              <Body3 color="White">🏡 편리한 매물 및 고객관리</Body3>
            </Chip>
            <Wrap direction="column" gap="7px">
              <Body4>다국어 매물 번역 시스템을 통한 간편한 매물 등록 제공</Body4>
              <Body4>대면 응대 없이 비대면으로 빠르게 가계약 확정 기능</Body4>
            </Wrap>
          </Block>
          <Block>
            <Chip>
              <Body3 color="White">📈 끝까지 책임지는 계약 진행</Body3>
            </Chip>
            <Wrap direction="column" gap="7px">
              <Body4>가계약 접수와 수락, 계약금 송금까지,</Body4>
              <Body4>체크메이트코리아가 직접 챙겨드립니다.</Body4>
            </Wrap>
          </Block>
        </Wrap>
      </Wrap>
      <Spacing height={172} />
      <Wrap
        gap={isMobile ? '32px' : '97px'}
        direction={isMobile ? 'column' : 'row'}
        padding={isMobile ? '0 16px' : '0px'}
        width={isMobile ? '100%' : undefined}
      >
        <Wrap direction="column" align="start" width={isMobile ? '100%' : undefined}>
          <T3 color="Red">Partner</T3>
          <Spacing height={7} />
          <H4>외국인 주거 시장의 새로운 가능성을</H4>
          <H4>새로운 가능성을</H4>
          <H4>열어갈 파트너를 기다립니다.</H4>
          <Spacing height={35} />
          <Body2 color="Gray40">2024년 기준 대한민국의 외국인 인구는 250만 명을</Body2>
          <Body2 color="Gray40">달성했고, 빠른 속도로 늘어나고 있습니다.</Body2>
          <Spacing height={25} />
          <Body2 color="Gray40">체크메이트코리아는 높은 확장성과,</Body2>
          <Body2 color="Gray40">수익 창출이 기대되는 외국인 주거 시장의</Body2>
          <Body2 color="Gray40">메이저 주거 통합 플랫폼으로 성장하고자 합니다.</Body2>
        </Wrap>
        <img src="Partner.png" alt="partner" style={mobileImg} />
      </Wrap>
      <Spacing height={186} />
      <Wrap direction="column" background="rgba(255, 240, 240, 1)" width="100%">
        <Spacing height={94} />
        <T3 color="Red">Contact</T3>
        <Spacing height={7} />
        <H4>지금 체크메이트코리아에서</H4>
        <H4>외국인 고객을 만나보세요.</H4>
        <Spacing height={20} />
        <Body2 color="Gray40">원룸, 투룸, 쉐어하우스, 고시원, 기숙사 모두</Body2>
        <Body2 color="Gray40">체크메이트코리아에서 광고 가능합니다.</Body2>
        <Spacing height={35} />
        <RegisterButton
          onClick={() => {
            if (LoginStorage.isLogin()) {
              alert('로그아웃 후 회원가입을 진행해주세요.');
            } else {
              navigate('/login');
            }
          }}
        >
          <Caption3 color="White">회원가입 하러가기</Caption3>
        </RegisterButton>
        <Spacing height={94} />
      </Wrap>
    </Wrap>
  );
};

export default Home;
